/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import SlickSlider from './components/slick';

$(document).ready(function () {
  createProductSpin();
  createInputFile();
  let slickSlider = new SlickSlider();
  

  prestashop.on('updatedProduct', function (event) {
      createInputFile();


      if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
      const quantityInputSelector = '#quantity_wanted';
      let quantityInput = $(quantityInputSelector);

      // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
      quantityInput.trigger('touchspin.updatesettings', {min: minimalProductQuantity});
    }
    $($('.tabs .nav-link.active').attr('href')).addClass('active show').removeClass('fade');

    $('.js-product-images-modal').replaceWith(event.product_images_modal);
    slickSlider.init();



  });


  function createInputFile()
  {
    $('.js-file-input').on('change', (event) => {
      let target, file;

      if ((target = $(event.currentTarget)[0]) && (file = target.files[0])) {
        $(target).prev().text(file.name);
      }
    });
  }

    function createProductSpin()
    {
        const $quantityInput = $('#quantity_wanted');

        $quantityInput.TouchSpin({
        		verticalbuttons: true,
            buttondown_class: 'btn js-touchspin',
            buttonup_class: 'btn js-touchspin',
            min: parseInt($quantityInput.attr('min'), 10),
            max: 1000000
        });

        $('body').on('change keyup', '#quantity_wanted', (e) => {
            $(e.currentTarget).trigger('touchspin.stopspin');
            prestashop.emit('updateProduct', {
                eventType: 'updatedProductQuantity',
                event: e
            });
        });

    }
 /****lien ancre sur fiche produit****/   
    	$('.btn-link-anchor').each(function(i, el) {
    		$(el).on('click touchstart', e => {
    			if($(el).attr('data-open')){
    				if (prestashop.responsive.mobile) {
    					var height_remove=50+$( "#header .header-top").height();
    					$(".tab-content.visible--mobile section:nth-child(-n+2) .collapse").each(function(a, em) {
    							if($(em).hasClass("show")){
		  					 		height_remove=height_remove+$(".tab-content.visible--mobile .collapse.show").height();	
    							}
    					});
		  					$('a[href="#_mobile_'+$(el).attr('data-open')+'"]').trigger('click');
		  					var iPosTop = $('a[href="#_mobile_'+$(el).attr('data-open')+'"]').offset().top-height_remove;
		  			}
		  			else{
		  				$('a[href="#_desktop_'+$(el).attr('data-open')+'"]').trigger('click');	
		  				var iPosTop = $($(el).attr('href')).offset().top-($( "#header:not(.headroom--not-top)").height());
		  			}
		  		}
		  		else{
		  			var iPosTop = $($(el).attr('href')).offset().top-($( "#header:not(.headroom--not-top)").height());
		  			
		  		}
					$('html, body').animate({
						scrollTop: iPosTop}, 1200);
						e.preventDefault();					

	  		});	
			});	
			
			/**agence123 : click sur le nb avis en haut fiche produit sur mobile**/
	$('#bt_btn-review-list').on('click touchstart', e => { 
		
	  if (prestashop.responsive.mobile) {
			var height_remove=60+$( "#header .header-top").height();
    	$(".tab-content.visible--mobile section .collapse").each(function(a, em) {
    		if($(em).hasClass("show")){
		  			height_remove=height_remove+$(".tab-content.visible--mobile .collapse.show").height();	
    		}
    	});
    	$('a[href="#idTab9999"]').trigger('click');	

		  var iPosTop =  $($('a[href="#idTab9999"]').attr('href')).offset().top-height_remove;
			
					$('html, body').animate({
					scrollTop: iPosTop
				}, 1200);	
			  	e.preventDefault();
		}
				
		});	
	if (prestashop.responsive.mobile) {	
		$($('a[href="#idTab9999"]').attr('href')).on('hidden.bs.collapse', function () {
  		$('a[href="#idTab9999"]').attr('aria-expanded',"false");	
		});
		$($('a[href="#idTab9999"]').attr('href')).on('shown.bs.collapse', function () {
  		$('a[href="#idTab9999"]').attr('aria-expanded',"true");	
		});
	}
	
	

	
});

$(document).on('shown.bs.modal','#product-modal', function (e) {
	var slidesToScroll=$(e.relatedTarget).attr('data-slick-slidesToScroll');
	$('#js-slick-product').slick('slickGoTo', slidesToScroll, true);
    $('#js-slick-product').resize();
    
});



//add to cart loader
$(document).on('click','.js-add-to-cart:enabled:not(.is--loading)',function(){
    $(this).addClass('is--loading').attr("disabled", true);
});
prestashop.on('updateCart', function (event) {
    removeAddToCartLoader();

});
prestashop.on('handleError', function (event) {
    removeAddToCartLoader();
    $('.js-add-to-cart').attr("disabled", false);

});
function removeAddToCartLoader(){
    $('.js-add-to-cart.is--loading').removeClass('is--loading');

}

//agence123 : partie droite de la fiche produit fixe
 	if(prestashop.responsive.current_width>1300){
 $(window).scroll(function () {

      var $this = $(this),
          $head = $('.custom_col'),
          $customcolHeight = $('.custom_col').height(),
          $scrollHeight = $('.product-content-img').height() - $customcolHeight;   

      if ($this.scrollTop() > 120 && $this.scrollTop() < $scrollHeight) {
        $head.addClass('fixed_col');
        $head.removeClass('absolute_col');
      }else if($this.scrollTop() > $scrollHeight){
        $head.removeClass('fixed_col');
        $head.addClass('absolute_col');
      }else {
        $head.removeClass('fixed_col');
        $head.removeClass('absolute_col');
      }
    });
}

//agence123 : lire la suite sur page CMS appel� dans onglet fiche produit
$(window).on("load", function(){
	$(".product-tabs .toggle").click(function(e) {
		var status = $(this).hasClass("open_next");
		if(!status){
				$(this).nextAll().show('fast');
				$(this).removeClass("close_next");
				$(this).addClass("open_next");	
		}
		else{
				$(this).nextAll().hide('fast');
				$(this).removeClass("open_next");
				$(this).addClass("close_next");	
		}
		});
});	

